import { User } from './../../models/user';
import { AuthFacade } from './../../auth/state/auth.facade';
import { Place } from './../../models/place';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseUtilitiesService } from '../../shared/base.utilities.service';

@Injectable()
export class PlaceUtilitiesService extends BaseUtilitiesService<Place> {
	constructor(authFacade: AuthFacade) {
		super(authFacade);
	}

	public map(place: Place, currentUser: User): Observable<Place> {
		if (place.logo == "" || place.logo == null) {
			place.logo = "./assets/images/defaultavatarplace.png";
		}
		return of(place);
	}
}
